document.addEventListener('DOMContentLoaded', () => {
  // フッター: PC時はdetailsを開いた状態に固定、SP時は閉じた状態で開閉可能
  const syncFooterDetails = () => {
    const is_desktop = window.innerWidth >= 750;
    document.querySelectorAll('.footer-block__details').forEach(detail => {
      if (is_desktop) {
        detail.setAttribute('open', '');
      } else {
        detail.removeAttribute('open');
      }
    });
  };
  syncFooterDetails();
  window.addEventListener('resize', syncFooterDetails);

  // page top
  class CMTopButton {
    static initialized = false;
    constructor() {
      if (CMTopButton.initialized) return;
      CMTopButton.initialized = true;
      this.page_top_button = document.querySelector('.cm-top-button');
      if (!this.page_top_button) return;
      this.page_top_button.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
      window.addEventListener('scroll', () => {
        if (window.pageYOffset > 100) {
          this.page_top_button.classList.add('is-visible');
        } else {
          this.page_top_button.classList.remove('is-visible');
        }
      });
    }
  }
  new CMTopButton();
  // end page top

  // 検索対策
  const search_forms = document.querySelectorAll('.search');
  if(search_forms != null) {
    search_forms.forEach((search_form)=>{
      const search_input = search_form.querySelector('.search__input');
      if(search_input.value.match(' -tag:ギフトボックス不可')) {
        search_input.value = search_input.value.replace(' -tag:ギフトボックス不可', '');
      }
      search_form.addEventListener('submit', (e)=>{
        if(search_input != null) {
          if(search_input.value.match('ギフトボックス') || search_input.value.match('ギフト')|| search_input.value.match('ボックス')) {
            if(!search_input.value.match('-tag:ギフトボックス不可')) {
              const span = document.createElement('span');
              span.classList.add('search__input');
              span.classList.add('field__input');
              span.textContent = search_input.value;
              span.style.lineHeight = 1;
              search_input.value = search_input.value + ' -tag:ギフトボックス不可';
              search_input.style.display = 'none';
              search_input.parentNode.insertBefore(span, search_input);
            }
          }
        } 
      });
    });
  }
  // 検索対策
});